<template>
  <input-comp @change="setCodigo" v-model="codigo" label="Código"/>
</template>

<script>
  import InputComp from "../../../Componentes_Globales/Input/inputComp";

  export default {
    name: "Codigo",
    components: {InputComp},
    methods: {
      setCodigo(){
        this.$store.commit("generarGuia/SET_FILTRO", {key: "codigo", value: this.codigo})
        this.$store.dispatch("generarGuia/getCarroGuia")
        this.$store.commit("generarGuia/UPDATE_STATE_KEY", {key: "carroPaso", data: []})

      }
    },
    data(){
      return{
        codigo: ""
      }
    }
  }
</script>

<style scoped>

</style>
